import type { Component } from 'vue';

import AempschedClassSchedule from './class-schedule/ClassSchedulesParent.vue';
import AempschedEmbeddedSchedule from './embedded-schedule/EmbeddedSchedule.vue';

export default {
	AempschedClassSchedule,
	AempschedEmbeddedSchedule
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
} as { [key: string]: Component<any, any, any, any, any> };
